var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-page"},[_c('div',{staticClass:"review-page--content"},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_c('b-container')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }